import React from 'react';
import { useSelector } from 'react-redux';
import AccessUsers from './AccessUsers/AccessUsers';
import {
  activeCompanySelector,
  connectedPageSelector,
} from '@mm/state/selectors/viewSelectors';

export const UserSettingsSection = () => {
  const company = useSelector(activeCompanySelector);
  const connectedPage = useSelector(connectedPageSelector);

  return (
    <div className="user-settings-section">
      {company && connectedPage && (
        <AccessUsers facebookPageId={connectedPage.id} companyId={company.id} />
      )}
    </div>
  );
};
